import {
  Box,
  Text,
  Stack,
  VStack,
  Link,
  HStack,
  Container,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import Logo from "./Logo";
import {
  FacebookProfile,
  InstagramProfile,
} from "~/components/SocialMediaButtons";

const MainMenuLinks = [
  <Link as={RouterLink} key={"sklep"} to="/#sklep">
    Sklep
  </Link>,
  <Link as={RouterLink} key={"onas"} to="/#o-nas">
    O nas
  </Link>,
  <Link as={RouterLink} key={"kontakt"} to="/#kontakt">
    Kontakt
  </Link>,
];

export default function Footer() {
  return (
    <Box
      as="div"
      backgroundColor={"#8CAAA0"}
      width="100vw"
      position="relative"
      left={"50%"}
      ml={"-50vw"}
      maxWidth={"100vw"}
      zIndex={0}
      borderTop={"solid 2px black"}
    >
      <Stack
        as={Container}
        color={"white"}
        maxW={1220}
        direction={["column", "column", "row", "row"]}
        pt={8}
        px={8}
        spacing={8}
        alignItems={"top"}
        justifyContent={"space-between"}
        zIndex={10}
      >
        <Box>
          <Text size="sm" fontWeight={"bold"}>
            Wydawnictwo Dystans - Kamil Czogała
          </Text>
          <Text fontSize={"sm"}>
            al. Hallera 98/24
            <br />
            53-203 Wrocław
            <br />
            +48 505541948
            <br />
            NIP: 6391916917
            <br />
            REGON: 526438634
            <br />
            <b>
              <Link href="mailto:kontakt@dystans.cc">kontakt@dystans.cc</Link>
            </b>
          </Text>
          <br />
          <Text></Text>
        </Box>
        <Box>
          <Text size="sm" pb={2} fontWeight={"bold"}>
            Strona
          </Text>
          <VStack mt={4} align={"left"} fontSize={"sm"}>
            {MainMenuLinks}
          </VStack>
        </Box>
        <Box>
          <Text size="sm" pb={2} fontWeight={"bold"}>
            Prawne
          </Text>
          <VStack mt={4} align={"left"} fontSize={"sm"}>
            <Link as={RouterLink} to="/regulamin">
              Regulamin sklepu
            </Link>
            <Link as={RouterLink} to="/polityka-prywatnosci">
              Polityka prywatności
            </Link>
            <Link as={RouterLink} to="/dostawa">
              Dostawa
            </Link>
          </VStack>
        </Box>

        <Box alignContent={"center"}>
          <VStack>
            <Logo
              loading={"lazy"}
              fetchPriority={"low"}
              logoColor={"white"}
              width={150}
            />
            <HStack>
              <FacebookProfile size={28} />
              <InstagramProfile size={28} />
            </HStack>
          </VStack>
        </Box>
      </Stack>
      <Stack
        justifyContent={"center"}
        p={8}
        direction={{ base: "column", md: "row" }}
      >
        <Text fontSize={"sm"} color={"white"}>
          photos @{" "}
          <Link as={RouterLink} to="https://szymon.bike">
            szymonbike
          </Link>
        </Text>
        <Text fontSize={"sm"} color={"white"}>
          Copyright @ Wydawnictwo Dystans 2025.
        </Text>
      </Stack>
    </Box>
  );
}
